import { render, staticRenderFns } from "./SpaceChoose.vue?vue&type=template&id=18e9462d&scoped=true&"
import script from "./SpaceChoose.vue?vue&type=script&lang=js&"
export * from "./SpaceChoose.vue?vue&type=script&lang=js&"
import style0 from "./SpaceChoose.vue?vue&type=style&index=0&id=18e9462d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e9462d",
  null
  
)

export default component.exports